import Card from "antd/es/card/Card";
import CoverageBenefits from "entities/CoverageBenefits";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { MdAdd } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import Header from "shared/components/Header";
import Search from "shared/components/Input";
import { NAME_SPACES } from "shared/locales/constants";
import { INITIAL_VALUES, SCREENS } from "utils/constants";
import View from "./View";

const List = () => {
  const [pagination, setPagination] = useState({});
  const [filter, setFilter] = useState(INITIAL_VALUES);
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.COVERAGE);
  const navigate = useNavigate();
  const LIST = t("LIST", { returnObjects: true });

  const buttons = [
    {
      icon: <MdAdd size={24} />,
      text: LIST.HEADER.SAVE,
      onClick: () => navigate(SCREENS.PRIVATE.ADMIN.COVERAGES.CREATE.path),
    },
  ];

  return (
    <>
      <Header title={LIST.HEADER.TITLE} actions={buttons} />
      <Card type="simple">
        <div className="m-bottom-20 grid--4">
          <Search
            placeholder={LIST.FILTERS.SEARCH}
            type="search"
            onChange={({ target }) => {
              setPagination((prev) => ({ ...prev, skip: 0 }));
              setFilter((prev) => ({
                ...prev,
                like: {
                  OR: [
                    { type: `%${target.value}%` },
                    { subtype: `%${target.value}%` },
                  ],
                },
              }));
            }}
          />
        </div>
        <CoverageBenefits
          View={View}
          filter={{ ...filter, ...pagination }}
          setValues={setPagination}
          skip={pagination.skip || 0}
          NoData={View}
        />
      </Card>
    </>
  );
};

export default List;
